import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fe36932"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0 py-5\" data-v-2fe36932><h3 class=\"card-title align-items-start flex-column\" data-v-2fe36932><span class=\"card-label fw-bolder fs-3 mb-1\" data-v-2fe36932>Total Bins <i class=\"bi bi-trash-fill fa-sm\" style=\"font-size:1.5rem;\" data-v-2fe36932></i></span></h3><div class=\"card-toolbar\" data-v-2fe36932></div></div>", 1)
const _hoisted_2 = { class: "card-body d-flex flex-column pt-0" }
const _hoisted_3 = { class: "d-flex flex-stack mb-5" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center me-2\" data-v-2fe36932><div class=\"symbol symbol-50px me-3\" data-v-2fe36932><div class=\"symbol-label bg-light\" data-v-2fe36932><i class=\"bi bi-trash-fill fa-2x text-primary\" data-v-2fe36932></i></div></div><div data-v-2fe36932><a href=\"#\" class=\"fs-6 text-gray-800 text-hover-primary fw-bolder\" data-v-2fe36932>Total Bins</a></div></div>", 1)
const _hoisted_5 = { class: "badge badge-light fw-bold p-4 px-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar bg-primary progress-bar progress-bar-striped progress-bar-animated",
    role: "progressbar",
    style: {"width":"100%"},
    "aria-valuenow": "100",
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  })
], -1))
const _hoisted_7 = { class: "d-flex flex-stack mb-5" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center me-2\" data-v-2fe36932><div class=\"symbol symbol-50px me-3\" data-v-2fe36932><div class=\"symbol-label bg-light\" data-v-2fe36932><i class=\"bi bi-trash-fill fa-2x text-success\" data-v-2fe36932></i></div></div><div data-v-2fe36932><a href=\"#\" class=\"fs-6 text-gray-800 text-hover-primary fw-bolder\" data-v-2fe36932>Active Bins</a></div></div>", 1)
const _hoisted_9 = { class: "badge badge-light fw-bold py-4 px-3" }
const _hoisted_10 = { class: "progress" }
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = { class: "d-flex flex-stack mb-5" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center me-2\" data-v-2fe36932><div class=\"symbol symbol-50px me-3\" data-v-2fe36932><div class=\"symbol-label bg-light\" data-v-2fe36932><i class=\"bi bi-trash-fill fa-2x full-bin\" data-v-2fe36932></i></div></div><div data-v-2fe36932><a href=\"#\" class=\"fs-6 text-gray-800 text-hover-primary fw-bolder\" data-v-2fe36932>Full Bins</a></div></div>", 1)
const _hoisted_14 = { class: "badge badge-light fw-bold p-4 px-3" }
const _hoisted_15 = { class: "progress" }
const _hoisted_16 = { class: "d-flex flex-stack mb-5" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center me-2\" data-v-2fe36932><div class=\"symbol symbol-50px me-3\" data-v-2fe36932><div class=\"symbol-label bg-light\" data-v-2fe36932><i class=\"bi bi-trash-fill fa-2x overflow-bin\" data-v-2fe36932></i></div></div><div data-v-2fe36932><a href=\"#\" class=\"fs-6 text-gray-800 text-hover-primary fw-bolder\" data-v-2fe36932>OverFlowing Bins</a></div></div>", 1)
const _hoisted_18 = { class: "badge badge-light fw-bold p-4 px-3" }
const _hoisted_19 = { class: "progress" }
const _hoisted_20 = { class: "d-flex flex-stack mb-5" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center me-2\" data-v-2fe36932><div class=\"symbol symbol-50px me-3\" data-v-2fe36932><div class=\"symbol-label bg-light\" data-v-2fe36932><i class=\"bi bi-trash-fill fa-2x garbage-around\" data-v-2fe36932></i></div></div><div data-v-2fe36932><a href=\"#\" class=\"fs-6 text-gray-800 text-hover-primary fw-bolder\" data-v-2fe36932>Garbage Around</a></div></div>", 1)
const _hoisted_22 = { class: "badge badge-light fw-bold p-4 px-3" }
const _hoisted_23 = { class: "progress" }
const _hoisted_24 = { class: "d-flex flex-stack mb-5" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center me-2\" data-v-2fe36932><div class=\"symbol symbol-50px me-3\" data-v-2fe36932><div class=\"symbol-label bg-light\" data-v-2fe36932><i class=\"bi bi-trash fa-2x\" data-v-2fe36932></i></div></div><div data-v-2fe36932><a href=\"#\" class=\"fs-6 text-gray-800 text-hover-primary fw-bolder\" data-v-2fe36932>Offline Bins</a></div></div>", 1)
const _hoisted_26 = { class: "badge badge-light fw-bold py-4 px-3" }
const _hoisted_27 = { class: "progress" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card shadow-sm"])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.totalBins), 1)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.response.active?.total), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: "progress-bar bg-success progress-bar progress-bar-striped progress-bar-animated",
          role: "progressbar",
          style: _normalizeStyle('width:' + (_ctx.response.active?.total / _ctx.totalBins) * 100 + '%'),
          "aria-valuenow": "{{response.active?.total}}",
          "aria-valuemin": "0",
          "aria-valuemax": "{{totalBins}}"
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.response.full?.total), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "progress-bar progress-bar progress-bar-striped progress-bar-animated",
            role: "progressbar",
            style: _normalizeStyle(['width:' + (_ctx.response.full?.total / _ctx.totalBins) * 100 + '%', {"background-color":"rgb(163, 97, 168)"}]),
            "aria-valuenow": "{{response.full?.total}}",
            "aria-valuemin": "0",
            "aria-valuemax": "{{totalBins}}"
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.response.overflowing?.total), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "progress-bar bg-primary progress-bar progress-bar-striped progress-bar-animated overflow-bins",
            role: "progressbar",
            style: _normalizeStyle([{"width":"100%"}, 'width:' + (_ctx.response.overflowing?.total / _ctx.totalBins) * 100 + '%']),
            "aria-valuenow": "{{response.overflowing?.total}}",
            "aria-valuemin": "0",
            "aria-valuemax": "{{totalBins}}"
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.response.garbage_around?.total), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "garbage-arounds progress-bar bg-primary progress-bar progress-bar-striped progress-bar-animated",
            role: "progressbar",
            style: _normalizeStyle([{"width":"100%"}, 
            'width:' + (_ctx.response.garbage_around?.total / _ctx.totalBins) * 100 + '%'
          ]),
            "aria-valuenow": "{{response.garbage_around?.total}}",
            "aria-valuemin": "0",
            "aria-valuemax": "{{totalBins}}"
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.response.offline?.total), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", {
            class: "progress-bar bg-secondary progress-bar progress-bar-striped progress-bar-animated",
            role: "progressbar",
            style: _normalizeStyle('width:' + (_ctx.response.offline?.total / _ctx.totalBins) * 100 + '%'),
            "aria-valuenow": "{{response.offline?.total}}",
            "aria-valuemin": "0",
            "aria-valuemax": "{{totalBins}}"
          }, null, 4)
        ])
      ])
    ])
  ], 2))
}